<template >
    <div id="wrapper">
        <div id="background">
            <div class="hardtech-logo">
                <img class="logo" src="../assets/logo2.png" alt="hardtech-logo">
            </div>
            <div class="info-logos">
                <img class="info-logo" src="../assets/email.svg" alt="hardtech-logo">
                <img class="info-logo" src="../assets/folder.svg" alt="hardtech-logo">
                <img class="info-logo" src="../assets/old-typical-phone.svg" alt="hardtech-logo">
            </div>
            <div class="hardtech-text">

            </div>
<!--            <div class="hardtech-text">-->
<!--                <h2>Hardtech Accelerator</h2>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

    #background{
        background: white;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .hardtech-text{
        text-align: center;
        color: white;
    }

    .hardtech-logo{
        position: relative;
        top: 20%;
    }

    .logo{

        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 25%;
    }

    .info-logos{
        position: relative;
        top: 20%;
        text-align: center;
    }

    .info-logo{
        display: inline-block;
        /*margin-left: auto;*/
        /*margin-right: auto;*/
        width: 5%;
        background-color: #ffffff47;
        padding: 1rem;
        border-radius: 10px;
        margin-right: 25px;
        margin-left: 25px;
        transition: box-shadow 0.3s ease;
    }

    .info-logo:hover{
        /*background-color: white;*/
        box-shadow: 0 0 5px 6px #ccc;
        cursor: pointer;
    }

</style>
